import type { ApolloError } from '@apollo/client';
import { metrics } from '@seek/metrics-js';
import { useMemo } from 'react';

import { isGraphQLUnauthenticatedError } from 'src/modules/graphql';
import { useDispatch, useSelector } from 'src/store/react';
import { selectServerAuthenticated } from 'src/store/selectors';
import { updateServerAuthenticated } from 'src/store/user';

export const useReflectSSRAuthStatusFromError = (error?: ApolloError) => {
  const isServerAuthenticated = useSelector(selectServerAuthenticated);
  const hasServerAuthError = useMemo(
    () =>
      isServerAuthenticated && error && isGraphQLUnauthenticatedError(error),
    [error, isServerAuthenticated],
  );
  const dispatch = useDispatch();

  if (ENV.SERVER && hasServerAuthError && isServerAuthenticated) {
    metrics.count('auth.event', [
      'event:serverFetchAuthFailure',
      'action:useHomeRecommendations',
    ]);
    dispatch(updateServerAuthenticated({ serverAuthenticated: false }));
  }
};
